import type { RouteRecordRaw } from 'vue-router'
import { AppModule } from '@/config/types'
import FormSubscribeDetails from '@/data/models/domain/services/forms/FormSubscribeDetails'
import type { NotFoundResolverParams } from '@/services/resolvers/types'
import FormClickToTextDetails from '@/data/models/domain/services/forms/FormClickToTextDetails'
import { FormsRoutes } from '@/routes/user/forms/types'
import DetailsHeroPageResolver from '@/components/resolvers/DetailsHeroPageResolver.vue'

export const getFormsDetailsRoutes = (): RouteRecordRaw[] => [
  {
    name: FormsRoutes.createClickToText,
    path: 'forms/click-to-text/new',
    meta: {
      parent: FormsRoutes.index,
      tabTitle: 'pageTabTitle.user.services.forms.clickToText.new',
      modules: [AppModule.ContactList, AppModule.WidgetClickToText],
      permission: 'subscribeForms',
    },
    component: () => import('@/components/views/services/forms/FormClickToText.vue'),
  },
  {
    name: FormsRoutes.editClickToText,
    path: 'forms/click-to-text/:formId',
    props: true,
    meta: {
      parent: FormsRoutes.index,
      tabTitle: 'pageTabTitle.user.services.forms.clickToText.edit',
      modules: [AppModule.ContactList, AppModule.WidgetClickToText],
      permission: 'subscribeForms',
      resolvers: [
        {
          service: 'RedirectableSingleModelResolverService',
          params: {
            model: FormClickToTextDetails,
            source: 'router',
            requestParam: 'formId',
            redirectToIfNotFound: { name: FormsRoutes.clickToText },
          } as NotFoundResolverParams,
        },
      ],
      resolverComponent: DetailsHeroPageResolver,
    },
    component: () => import('@/components/views/services/forms/FormClickToText.vue'),
  },
  {
    name: FormsRoutes.editSubscribe,
    path: 'forms/subscribe/:formId',
    props: true,
    meta: {
      parent: FormsRoutes.index,
      tabTitle: 'pageTabTitle.user.services.forms.subscribe.edit',
      modules: [AppModule.ContactList, AppModule.WidgetSubscribe],
      permission: 'subscribeForms',
      resolverComponent: DetailsHeroPageResolver,
      resolvers: [
        {
          service: 'RedirectableSingleModelResolverService',
          params: {
            model: FormSubscribeDetails,
            source: 'router',
            requestParam: 'formId',
            redirectToIfNotFound: { name: FormsRoutes.subscribe },
          } as NotFoundResolverParams,
        },
      ],
    },
    component: () => import('@/components/views/services/forms/FormSubscribe.vue'),
  },
]
